import { lazy } from 'react';

export const CommunityPage = lazy(() => import('./CommunityPage'));
